import { render, staticRenderFns } from "./ProductSingleDescription.vue?vue&type=template&id=02a0d884&"
import script from "./ProductSingleDescription.vue?vue&type=script&lang=js&"
export * from "./ProductSingleDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports